import { render, staticRenderFns } from "./CourseReportTable.vue?vue&type=template&id=3aaa008a&"
import script from "./CourseReportTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseReportTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports